import { Search, Calendar, SlidersHorizontal, X } from 'lucide-react';
import type { FilterState } from '../types';

interface FiltersProps {
  filters: FilterState;
  onChange: (filters: FilterState) => void;
}

export function Filters({ filters, onChange }: FiltersProps) {
  const update = (key: keyof FilterState, value: any) => {
    onChange({ ...filters, [key]: value });
  };

  const clearFilters = () => {
    onChange({
      dateFrom: '',
      dateTo: '',
      status: 'all',
      customerSearch: '',
      minAmount: '',
      maxAmount: '',
    });
  };

  const hasActiveFilters = filters.status !== 'all' || filters.customerSearch || filters.dateFrom || filters.dateTo || filters.minAmount !== '' || filters.maxAmount !== '';

  return (
    <div className="oem-card p-5 space-y-4">
      <div className="flex items-center gap-2 text-oem-800">
        <SlidersHorizontal className="w-5 h-5 text-oem-500" />
        <h3 className="font-semibold text-oem-900">Filters</h3>
        {hasActiveFilters && (
          <button
            onClick={clearFilters}
            className="ml-auto text-sm text-accent-600 hover:text-accent-700 flex items-center gap-1 font-medium"
          >
            <X className="w-3.5 h-3.5" />
            Clear all
          </button>
        )}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-6 gap-3">
        <div className="space-y-1.5">
          <label className="text-xs font-medium text-oem-500">Date From</label>
          <div className="relative">
            <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-oem-400" />
            <input
              type="date"
              value={filters.dateFrom}
              onChange={(e) => update('dateFrom', e.target.value)}
              className="oem-input w-full pl-9"
            />
          </div>
        </div>

        <div className="space-y-1.5">
          <label className="text-xs font-medium text-oem-500">Date To</label>
          <div className="relative">
            <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-oem-400" />
            <input
              type="date"
              value={filters.dateTo}
              onChange={(e) => update('dateTo', e.target.value)}
              className="oem-input w-full pl-9"
            />
          </div>
        </div>

        <div className="space-y-1.5">
          <label className="text-xs font-medium text-oem-500">Status</label>
          <select
            value={filters.status}
            onChange={(e) => update('status', e.target.value)}
            className="oem-input w-full"
          >
            <option value="all">All Statuses</option>
            <option value="unknown">Unknown</option>
            <option value="automation">Automation</option>
            <option value="intervention">Intervention</option>
            <option value="escalation">Escalation</option>
          </select>
        </div>

        <div className="space-y-1.5">
          <label className="text-xs font-medium text-oem-500">Customer or PO</label>
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-oem-400" />
            <input
              type="text"
              placeholder="Name, PO #, part…"
              value={filters.customerSearch}
              onChange={(e) => update('customerSearch', e.target.value)}
              className="oem-input w-full pl-9"
            />
          </div>
        </div>

        <div className="space-y-1.5">
          <label className="text-xs font-medium text-oem-500">Min Amount</label>
          <input
            type="number"
            placeholder="0"
            value={filters.minAmount}
            onChange={(e) => update('minAmount', e.target.value === '' ? '' : Number(e.target.value))}
            className="oem-input w-full"
          />
        </div>

        <div className="space-y-1.5">
          <label className="text-xs font-medium text-oem-500">Max Amount</label>
          <input
            type="number"
            placeholder="∞"
            value={filters.maxAmount}
            onChange={(e) => update('maxAmount', e.target.value === '' ? '' : Number(e.target.value))}
            className="oem-input w-full"
          />
        </div>
      </div>
    </div>
  );
}
